import type { TFunction } from 'i18next'

import type { SelectFieldOption } from '@/components/inputs/CustomSelectField'
import type { Site } from '@/features/site/types/site'

export function getCountryOptions(sites: Site[], t: TFunction): SelectFieldOption<string>[] {
  const uniqueCountryCodes: CountryIdentifier[] = Array.from(
    new Set(sites.filter((c) => !!c.countryCode).map((c) => c.countryCode!.toLowerCase() as CountryIdentifier)),
  )

  return uniqueCountryCodes.map((countryCode) => ({
    id: countryCode,
    value: countryCode,
    label: t(`common.country.${countryCode}`),
  }))
}
